export default __webpack_public_path__ + "static/media/Saly-43-1.05fb89bb.png";